<script setup lang="ts">
import type { PropType } from "vue";
import type { Collection } from "~/types";
import VideoPlayer from "~/components/VideoPlayer.vue";
import { getThumbnailImage } from "~/utils/common";
import CountdownTimer from "~/components/Video/CountdownTimer.vue";

const props = defineProps({
  video: {
    type: Object as PropType<Collection & { onAir: boolean }>,
    required: true,
  },
});

const videoSource = computed(() => {
  if (props.video?.type === "live") {
    return [{ file: props.video.source }];
  } else {
    return "https://cdn.jwplayer.com/v2/media/" + props.video.source;
  }
});
</script>

<template>
  <div v-if="video.onAir">
    <VideoPlayer
      :id="video.id"
      ref="videoPlayerRef"
      :source="videoSource"
      :duration="video.duration"
      :video-type="video.type"
      :track-progress="true"
      :progress="0"
    />
  </div>
  <div v-else>
    <NuxtImg
      alt="thumbnail"
      class="w-screen"
      :src="getThumbnailImage([video.pre_air_images, video.images])"
      placeholder="/images/placeholder.png"
      loading="lazy"
    />

    <CountdownTimer
      :air-date="new Date(video.aired_at)"
      :video-type="video.type"
    />
  </div>
</template>

<style scoped></style>
